import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

import { Fallback } from './ErrorPage';

function LayoutPage(): JSX.Element {
  return (
    <ErrorBoundary FallbackComponent={Fallback}>
      <Outlet />
    </ErrorBoundary>
  );
}

export default LayoutPage;
